import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Grid, CircularProgress } from '@mui/material';
import api from '../../services/api.js';
import { TableKit } from '@NP-Webber/crm-kit';

const Reports = () => {
  const [byCityData, setByCityData] = useState([]);
  const [top90Data, setTop90Data] = useState([]);
  const [passRateData, setPassRateData] = useState([]);
  const [avgData, setAvgData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [byCity, top90, passRates, avg] = await Promise.all([
          api.get('/reports/by-city'),
          api.get('/reports/top90'),
          api.get('/reports/pass-rates'),
          api.get('/reports/avg-scores'),
        ]);
        setByCityData(byCity.data.data);
        setTop90Data(top90.data.data);
        setPassRateData(passRates.data.data);
        setAvgData(avg.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  const byCityColumns = [
    { key: 'city', title: 'עיר', sortable: false },
    { key: 'count', title: 'מספר חברים', sortable: false },
  ];

  const top90Columns = [
    { key: 'memberId', title: 'שם', sortable: false, render: (v) => v ? `${v.firstName} ${v.lastName}` : '—' },
    { key: 'examId', title: 'מבחן', sortable: false, render: (v) => v?.name || '—' },
    { key: 'score', title: 'ציון', sortable: false },
  ];

  const passRateColumns = [
    { key: 'group', title: 'קבוצה', sortable: false },
    { key: 'total', title: 'סה"כ', sortable: false },
    { key: 'passed', title: 'עברו', sortable: false },
    { key: 'passRate', title: 'אחוז מעבר', sortable: false, render: (v) => `${v?.toFixed(1)}%` },
  ];

  const avgColumns = [
    { key: 'examType', title: 'סוג מבחן', sortable: false },
    { key: 'avgScore', title: 'ציון ממוצע', sortable: false },
    { key: 'count', title: 'מספר ציונים', sortable: false },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        דוחות
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>נבחנים לפי עיר</Typography>
            <TableKit
              columns={byCityColumns}
              data={byCityData}
              total={byCityData.length}
              showFilters={false}
              showColumnPicker={false}
              exportFileName="נבחנים_לפי_עיר"
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>ציוני 90+</Typography>
            <TableKit
              columns={top90Columns}
              data={top90Data.slice(0, 20)}
              total={top90Data.length}
              showFilters={false}
              showColumnPicker={false}
              exportFileName="ציוני_90_פלוס"
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>אחוזי מעבר לפי סוג</Typography>
            <TableKit
              columns={passRateColumns}
              data={passRateData}
              total={passRateData.length}
              showFilters={false}
              showColumnPicker={false}
              exportFileName="אחוזי_מעבר"
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>ציון ממוצע לפי סוג</Typography>
            <TableKit
              columns={avgColumns}
              data={avgData}
              total={avgData.length}
              showFilters={false}
              showColumnPicker={false}
              exportFileName="ציונים_ממוצעים"
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Reports;
